<template>
  <v-card class="move-level">
    <v-subheader>
      <v-icon medium color="warning" class="mr-2">cached</v-icon>
      {{date}} <span class="ml-2 body-2">Перемещена дата старта уровня {{level}}</span>
    </v-subheader>
    <v-layout row>
      <v-flex>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Инфо: </span>Новая дата старта {{newStartDate}}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "MoveLevel",
    props: ["date", "description", "level", "newStartDate"]
  }
</script>

<style scoped>
  .move-level {
    border: 1px solid #78909C;
  }
</style>